<template>
  <div class="wh-flex-between">
    <div class="sensor-items wh-flex-between">
      <div v-for="n in sensor.weather" :key="n.name" class="sensor-item wh-flex-between">
        <div class="left-content">
          <div class="name">
            {{ n.name }}
          </div>
          <div class="unit">
            单位: {{ n.unit }}
          </div>
        </div>
        <div class="value">
          {{ n.value }}
        </div>
      </div>
      <div v-for="n in sensor.soilNutrient" :key="n.name" class="sensor-item wh-flex-between">
        <div class="left-content">
          <div class="name">
            {{ n.name }}
          </div>
          <div class="unit">
            单位: {{ n.unit }}
          </div>
        </div>
        <div class="value">
          {{ n.value }}
        </div>
      </div>
      <div v-for="n in sensor.soilStatus" :key="n.name" class="sensor-item wh-flex-between">
        <div class="left-content">
          <div class="name">
            {{ n.name }}
          </div>
          <div class="unit">
            单位: {{ n.unit }}
          </div>
        </div>
        <div class="value">
          {{ n.value }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  props: {
    userId: {
      type: Number,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sensor: {
        soilNutrient: [],
        soilStatus: [],
        weather: []
      }
    }
  },
  watch: {
    userId: {
      handler(newV) {
        if (newV) {
          this.getIotDevice(newV)
        }
      },
      immediate: true
    }
  },
  methods: {
    getIotDevice(userId) {
      api.getIotDeviceNoLogin({ userId }).then(({ data }) => {
        if (data.list && data.list.length) {
          const params = {
            productKey: data.list[0].productKey,
            deviceName: data.list[0].deviceName,
            userId
          }
          api.getDeviceDataNoLogin(params).then(({ data }) => {
            this.sensor.soilNutrient = data.soilNutrient.value
            this.sensor.soilStatus = data.soilStatus.value
            this.sensor.weather = data.weather.value
            this.$emit('update:visible', true)
          })
        }
      }).catch((e) => {
        console.error(e)
        this.$emit('update:visible', false)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.sensor-items {
  flex-wrap: wrap;
  margin-top: 20px;
  .sensor-item {
    margin-bottom: 10px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 5px;
    background: #e8f1fe;
    width: 48%;
    .name {
      font-size: 16px;
    }
    .unit {
      color: #ccc;
      font-size: 12px;
    }
    .value {
      font-size: 30px;
      font-family: 'LCD digital';
      color: @primary-color;
    }
  }
}
</style>
